import React, { Component } from 'react';
import './App.scss';
import ErrorBoundary from './helpers/ErrorBoundary';
import { Redirect, Route, Router, Switch } from 'react-router-dom';
import { history } from './helpers/history';
import MainLayout from './layout/MainLayout';
import DefaultLayout from './layout/DefaultLayout';
import Login from './modules/user/component/login';
import ChangePassword from './modules/user/component/changePassword';
import Signup from './modules/user/component/signup';
import ResetPassword from './modules/user/component/resetPassword';
import ForgotPassword from './modules/user/component/forgotPassword';
import Category from './modules/user/component/signUpCategory';
import UserProfile from './modules/user/component/userProfile';
// import PrivacyPolicy from './modules/user/component/privacyPolicy.html';
import BookingDetail from './modules/user/component/bookingDetail';
import AboutUs from './modules/user/component/aboutUs';
import Faq from './modules/user/component/faq';
import ServiceDetail from './modules/user/component/serviceDetail';
import ProviderDashboard from './modules/user/component/providerDeshbord';
import BidRequest from './modules/user/component/bidRequest';
import PrBidRequest from './modules/user/component/prBidRequest';
import MyBooking from './modules/user/component/myBooking';
import UserApproval from './modules/admin/component/userApproval'
import { connect } from 'react-redux';
import Admin from './modules/admin/component/login';
import AdminLayout from './modules/admin/component/adminLayout';
import TableComponent from './modules/user/component/dummyTable';
import DeleteAccount from './modules/user/component/deleteAccount';
import Biddings from './modules/admin/component/Biddings';
import Customers from './modules/admin/component/Customers';
import Providers from './modules/admin/component/Providers';
import Resolutions from './modules/admin/component/Resolutions';
import Referrals from './modules/admin/component/Referrals';
import SideNav from './layout/DefaultLayout/SideNav';

export class App extends Component {
  constructor() {
    super();
    this.state = {
      collapsed: false
    }

  }

  toggleCollapsed = () => {
    this.setState({ collapsed: !this.state.collapsed });
  };

  render() {
    const { user } = this.props;
    let role = user.role && user.role.name || 'Customer'
    return (
      <ErrorBoundary>
        <div className="App">
          <Router history={history}>
            <Switch>
              <Route exact path='/login' name='Login Page' component={Login} />
              <Route exact path='/changePassword' name='ChangePassword' component={ChangePassword} />
              <Route exact path='/:type/register' name='Signup' component={Signup} />
              <Route exact path='/signUpCategory' name='Category' component={Category} />
              <Route exact path='/resetPassword' name='ResetPassword' component={ResetPassword} />
              <Route exact path='/forgotPassword' name='ForgotPassword' component={ForgotPassword} />
              <Route exact path='/bookingDetail' name='BookingDetail' component={BookingDetail} />
              <Route exact path='/myBooking' name='MyBooking' component={MyBooking} />

              <Route exact path="/500" name="Page 500" component={(e) => { return <h3>not found</h3> }} />
              <Route exact path="/404" name="Page 404" component={(e) => { return <h3>not found</h3> }} />

              {/* //<Route exact path='/privacyPolicy' name='PrivacyPolicy' component={PrivacyPolicy} /> */}
              <Route exact path='/privacyPolicy' render={() => { window.location.href = "privacyPolicy.html" }} />
              <Route exact path='/aboutUs' name='AboutUs' component={AboutUs} />
              <Route exact path='/faq' name='Faq' component={Faq} />

              <Route exact path='/updateProfile' name='updateProfile' component={UserProfile} />
              <Route exact path='/admin' name='Login Page' component={Admin} />
              <Route exact path='/table' name='Dummy Grid' component={TableComponent} />
              <Route exact path='/deleteAccount' name='deleteAccount' component={DeleteAccount} />
              {/* <Route exact path="/adminDashboard" name="Home" component={AdminLayout} /> */}
              {
                role == 'Customer' && <div>
                  <Route exact path="/" name="Home" component={DefaultLayout} />
                  <Route exact path='/service/:categoryID' name='ServiceDetail' component={ServiceDetail} />
                  <Route exact path='/service/:categoryID/:subID' name='BidRequest' component={BidRequest} />
                </div>
              }

              {
                role == 'Provider' && <div>
                  <Route exact path='/' name='providerDashboard' component={ProviderDashboard} />
                  <Route exact path='/bid/:categoryID' name='PrBidRequest' component={PrBidRequest} />
                </div>
              }
              {
                role == 'Admin' && <div>
                  <SideNav collapsed={this.state.collapsed} toggleCollapsed={() => this.toggleCollapsed()}/>
                  <div className={`${this.state.collapsed ? 'collapsed' : 'expanded'}`}>
                  <Route exact path='/' name='biddings' component={Biddings} />
                  <Route exact path='/biddings' name='biddings' component={Biddings} />
                  <Route exact path='/customers' name='biddings' component={Customers} />
                  <Route exact path='/providers' name='biddings' component={Providers} />
                  <Route exact path='/userApproval' name='userApproval' component={UserApproval} />
                  <Route exact path='/bid/:categoryID' name='PrBidRequest' component={PrBidRequest} />
                  <Route exact path='/resolution' name='resolutions' component={Resolutions} />
                  <Route exact path='/referrals' name='referrals' component={Referrals} />
                  </div>

                </div>
              }



            </Switch>
          </Router>
        </div>
      </ErrorBoundary>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
  }
}
export default connect(mapStateToProps)(App);